import React, { useEffect, useState } from 'react';
import { nanoid } from 'nanoid';
import classNames from 'classnames';
import { BRAND_COLOR, PLATINUM_COLOR } from '../../common/constants';
import '../styles/svg-images.less';

/**
 * Quickley Logo
 */
export function Logo(props) {
  return (
    <svg viewBox="0 0 34 32" width={34} height={32} {...props}>
      <g fill="none">
        <path
          d="M1.25 20a8.183 8.183 0 0 1 0-8l4.5-8c1.392-2.475 3.965-4 6.75-4h9c2.785 0 5.358 1.525 6.75 4l4.5 8a8.183 8.183 0 0 1 0 8l-4.5 8c-1.392 2.475-3.965 4-6.75 4h-9c-2.785 0-5.358-1.525-6.75-4l-4.5-8z"
          fill="#0072FF"
        />
        <path
          d="M19.996 25.6h.06a4 4 0 0 0 3.477-2.024l3.182-5.6a4 4 0 0 0 0-3.952l-3.182-5.6A4 4 0 0 0 20.055 6.4h-6.257a4 4 0 0 0-3.477 2.024l-3.183 5.6a4 4 0 0 0 0 3.952l3.486 6.133a2.946 2.946 0 0 0 2.561 1.491h0a2.947 2.947 0 0 0 2.583-1.53l5.494-10.013"
          strokeWidth={3}
          stroke="#fff"
        />
      </g>
    </svg>
  );
}

/**
 * Шестиугольник с изображением внутри
 */
export const HexagonWithImage = (props) => {
  const { active, onErrorPic, ...rest } = props;
  const stroke = active ? BRAND_COLOR : 'transparent';

  let [id] = useState(nanoid());
  let [pic, setPic] = useState(props.pic);
  useEffect(() => {
    setPic(props.pic);
  }, [props.pic]);

  return (
    <svg viewBox={`0 0 88 84`} width={92} height={88} fill="none" {...rest}>
      <path
        d="M4.61147 52C1.12951 45.812 1.12951 38.188 4.61147 32L15.8653 12C19.3473 5.81198 25.7822 2 32.7461 2L55.2539 2C62.2178 2 68.6527 5.81198 72.1347 12L83.3885 32C86.8705 38.188 86.8705 45.812 83.3885 52L72.1347 72C68.6527 78.188 62.2178 82 55.2539 82H32.7461C25.7822 82 19.3473 78.188 15.8653 72L4.61147 52Z"
        fill={`url(#pattern__${id})`}
        stroke={stroke}
        strokeWidth={4}
      />
      <defs>
        <pattern id={`pattern__${id}`} width={2} height={2}>
          <image
            x={0}
            y={-2}
            width={84}
            xlinkHref={pic}
            onError={() => {
              setPic(onErrorPic);
            }}
          />
        </pattern>
      </defs>
    </svg>
  );
};

/**
 * Стрелочка вниз
 */
export const ArrowDown = (props) => (
  <svg width={12} height={4} fill="none" {...props}>
    <path d="M1 .75l5 2.5 5-2.5" stroke="#1a2b49" strokeLinecap="round" />
  </svg>
);

/**
 * Синхронизация
 */
export const Sync = (props) => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M16 2c7.732 0 14 6.268 14 14s-6.268 14-14 14c-5.461 0-10.192-3.127-12.5-7.689M16 5.5v9.27a2 2 0 01-1.099 1.785L6.5 20.797"
      stroke={props.color || PLATINUM_COLOR}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.38 19.244C.59 11.722 5.236 4.172 12.757 2.38"
      stroke={props.color || PLATINUM_COLOR}
      strokeWidth={2.2}
      strokeLinecap="round"
      strokeDasharray="0.08 4.8"
    />
  </svg>
);

/**
 * Trash icon
 */
export const Trash = (props) => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M26 12l-1.347 16.166A2 2 0 0122.66 30H10.34a2 2 0 01-1.993-1.834L7 12m19 0H7m19 0a2 2 0 002-2v-.5a2 2 0 00-2-2h-3m0 0H10m13 0l-1.928-3.471A2 2 0 0019.323 3h-5.646a2 2 0 00-1.748 1.029L10 7.5M21 16l-.5 10M7 12a2 2 0 01-2-2v-.5a2 2 0 012-2h3m2 8.5l.5 10m4-10v10"
      stroke={props.color || PLATINUM_COLOR}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Скрепка
 */
export const Attachment = (props) => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M19.571 8.707l-9.546 9.546a3.5 3.5 0 004.95 4.95l10.96-10.96a6 6 0 10-8.485-8.486L6.49 14.717a8.5 8.5 0 0012.02 12.021l6.01-6.01"
      stroke={props.color || PLATINUM_COLOR}
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);

/**
 * Смайлик
 */
export const Smile = (props) => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
    <circle cx={16} cy={16} r={14} stroke={props.color || PLATINUM_COLOR} strokeWidth={2} />
    <circle cx={11} cy={13} r={1.5} fill={props.color || PLATINUM_COLOR} />
    <circle cx={21} cy={13} r={1.5} fill={props.color || PLATINUM_COLOR} />
    <path
      d="M9.755 21A7.985 7.985 0 0016 24a7.985 7.985 0 006.245-3"
      stroke={props.color || PLATINUM_COLOR}
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);

/**
 * Предупреждение
 */
export const Attention = (props) => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
    <circle
      cx={16}
      cy={16}
      r={14}
      transform="rotate(180 16 16)"
      stroke={props.color || '#ef6544'}
      strokeWidth={2}
    />
    <circle
      cx={16}
      cy={22.5}
      r={1.5}
      transform="rotate(180 16 22.5)"
      fill={props.color || '#ef6544'}
    />
    <path d="M16 17V8" stroke={props.color || '#ef6544'} strokeWidth={2} strokeLinecap="round" />
  </svg>
);

/**
 * Колокольчик
 */
export const Bell = (props) => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M22.195 11.247l-.953.304.953-.304zm5.594 7.662l.952-.304-.952.304zm-1.946 3.77l.304.953-.304-.953zm-2.736-8.574l.952-.304-.952.304zm2.079 2.267l-.239.97a.584.584 0 00.019.005l.22-.975zm-20.14.347L6 16.415l-.952.304zm-.121 9.486l.952-.304-.952.304zm3.77 1.946l.304.953-.304-.953zm-2.736-8.574l-.953.304.953-.304zm-.382 3.052l.744.668a.896.896 0 00.013-.014l-.757-.654zM13.59 4.021l-.952.304.952-.304zM7.874 5.845l-.952.304.952-.304zm6.024-.86l-.03 1 .03-1zM18 25.182l-.305-.953.305.953zm-6.658 2.125l-.304-.953.304.953zm15.494-8.094a2 2 0 01-1.297 2.513l.608 1.906a4 4 0 002.594-5.027l-1.905.608zm-5.594-7.662l.912 2.858 1.905-.608-.912-2.858-1.905.608zm3.724 5.796c.928.21 1.583.965 1.87 1.866l1.905-.608c-.438-1.375-1.53-2.803-3.336-3.209l-.439 1.951zm-2.812-2.938c.137.431.726 2.426 2.793 2.934l.477-1.942c-.875-.215-1.198-1.078-1.365-1.6l-1.905.608zm-18.182 12.1A4 4 0 009 29.104l-.608-1.905A2 2 0 015.877 25.9l-1.905.608zm.122-9.486l.912 2.858 1.905-.608L6 16.415l-1.905.608zm.739 4.938c-1.236 1.377-1.3 3.173-.86 4.548l1.904-.608c-.287-.9-.192-1.896.444-2.604l-1.488-1.336zm.173-2.08c.166.522.402 1.413-.186 2.095l1.514 1.307c1.39-1.612.715-3.579.577-4.01l-1.905.608zm3.821-14.34c-.465-1.459.226-2.696 1.145-2.99L9.364.646c-2.237.714-3.152 3.278-2.442 5.503l1.905-.608zm1.145-2.99c.92-.293 2.2.315 2.666 1.774l1.905-.608c-.71-2.225-2.942-3.785-5.179-3.071l.608 1.905zm.608 1.906a9.985 9.985 0 00-3.002 1.555l1.208 1.594a7.986 7.986 0 012.402-1.244l-.608-1.905zM7.578 6.012C4.296 8.5 2.77 12.874 4.094 17.023l1.905-.608a8.004 8.004 0 012.787-8.809L7.578 6.012zm-.656.137l.307.964 1.906-.608-.308-.964-1.905.608zm4.266.213a7.986 7.986 0 012.68-.377l.06-2a9.985 9.985 0 00-3.348.472l.608 1.905zm2.68-.377a8.004 8.004 0 017.374 5.566l1.905-.608c-1.324-4.15-5.102-6.83-9.218-6.958l-.062 2zm-1.23-1.66l.307.964 1.906-.608-.308-.964-1.905.608zm4.598 22.125a2.5 2.5 0 01-2.5 2.5v2a4.5 4.5 0 004.5-4.5h-2zm-.169-.905c.11.279.17.584.17.905h2c0-.573-.108-1.123-.305-1.63l-1.864.724zm1.236.59l7.844-2.503-.608-1.906-7.844 2.503.608 1.906zM9 29.104l2.647-.845-.608-1.905-2.647.845.608 1.905zm2.647-.845l6.657-2.124-.608-1.906-6.657 2.125.608 1.905zm3.09.691a2.501 2.501 0 01-2.424-1.887l-1.94.488a4.501 4.501 0 004.364 3.4v-2z"
      fill={props.color || PLATINUM_COLOR}
    />
  </svg>
);

/**
 * Стрелочка для выпадающего списка
 * @param props
 * @returns {*}
 * @constructor
 */
export const DropdownArrow = (props) => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M4 13l11.106 5.553a2 2 0 001.788 0L28 13"
      stroke={props.color || PLATINUM_COLOR}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Logout = (props) => (
  <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
    <path
      d="M8.332 8c-.22.18-.433.37-.64.565A11.774 11.774 0 004 17.13C4 23.686 9.373 29 16 29s12-5.314 12-11.87c0-3.366-1.417-6.405-3.692-8.565-.207-.195-.42-.384-.64-.565M16 16V3"
      stroke={props.color || PLATINUM_COLOR}
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);

export function Speed(props) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M11.05 11.05L8.93 8.93M16 9V6m7 10h3M6 16h3m9.121-2.121l4.95-4.95m-4.95 4.95a3 3 0 10-4.243 4.242 3 3 0 004.243-4.242zM10.5 23.5h11M2 16C2 8.268 8.268 2 16 2s14 6.268 14 14c0 2.76-.798 5.332-2.176 7.5a14.07 14.07 0 01-4.892 4.666c-.28.16-.601.237-.925.237H9.993c-.324 0-.644-.076-.926-.237a14.07 14.07 0 01-4.89-4.666A13.934 13.934 0 012 16z"
        stroke={props.color || PLATINUM_COLOR}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Browser(props) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <circle cx={16} cy={16} r={14} stroke={props.color || PLATINUM_COLOR} strokeWidth={2} />
      <path
        d="M12.5 12.5l7 7m-9.995 2.383l2.457-9.213a1 1 0 01.708-.708l9.213-2.457a.5.5 0 01.612.612l-2.457 9.213a1 1 0 01-.708.708l-9.213 2.457a.5.5 0 01-.612-.612z"
        stroke={props.color || PLATINUM_COLOR}
        strokeWidth={2}
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function OS(props) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M20 22v4a2 2 0 002 2h6a2 2 0 002-2V14a2 2 0 00-2-2h-1m-7 10v-8a2 2 0 012-2h5m-7 10H5a3 3 0 01-3-3V7a3 3 0 013-3h19a3 3 0 013 3v5"
        stroke={props.color || PLATINUM_COLOR}
        strokeWidth={2}
      />
      <path
        d="M7 27h9"
        stroke={props.color || PLATINUM_COLOR}
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Location(props) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M27 12.5c0 7.157-8.405 15.516-10.175 17.197a.464.464 0 01-.65 0C14.405 28.016 6 19.657 6 12.5 6 6.701 10.701 2 16.5 2S27 6.701 27 12.5z"
        stroke={props.color || PLATINUM_COLOR}
        strokeWidth={2}
      />
      <circle cx={16.5} cy={12.5} r={4.5} stroke={props.color || PLATINUM_COLOR} strokeWidth={2} />
    </svg>
  );
}

export function Referrer(props) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M22.799 17.142l3.535-3.535A6 6 0 1017.85 5.12l-3.535 3.536m2.828 14.142l-3.535 3.535A6 6 0 115.12 17.85l3.536-3.535m11.314-2.829l-8.486 8.486"
        stroke={props.color || PLATINUM_COLOR}
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function LandingPage(props) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M3 9.5V7C3 4.79086 4.79086 3 7 3H25C27.2091 3 29 4.79086 29 7V25C29 27.2091 27.2091 29 25 29H7C4.79086 29 3 27.2091 3 25V22.5"
        stroke={props.color || PLATINUM_COLOR}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M3.5 16H21M21 16L16.5 20.5M21 16L16.5 11.5"
        stroke={props.color || PLATINUM_COLOR}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Check({
  checked = false,
  disabled = false,
  onClick = () => {},
  className,
  ...rest
}) {
  const class_name = classNames(
    'Check',
    {
      Check_checked: checked,
      Check_disabled: disabled,
    },
    className,
  );
  return (
    <svg
      className={class_name}
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      onClick={onClick}
      {...rest}
    >
      <path
        className="Check__plate"
        d="M1.61 9.755l3.215-5.5A4.582 4.582 0 018.785 2h6.43c1.639 0 3.147.863 3.96 2.255l3.216 5.5c.812 1.39.812 3.1 0 4.49l-3.216 5.5A4.583 4.583 0 0115.215 22h-6.43a4.582 4.582 0 01-3.96-2.255l-3.216-5.5a4.44 4.44 0 010-4.49z"
        strokeWidth="2"
      />
      <path
        className="Check__mark"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M6.621 12.24l2.845 3.442 7.5-7.172"
      />
    </svg>
  );
}

export function Edit(props) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M19.546 6.531L5.282 20.795a2 2 0 00-.585 1.414v4.828h4.828a2 2 0 001.414-.585l14.264-14.264m-5.657-5.657l2.828-2.828a2 2 0 012.829 0L28.03 6.53a2 2 0 010 2.829l-2.828 2.828m-5.657-5.657l5.657 5.657"
        stroke={props.color || PLATINUM_COLOR}
        strokeWidth={2}
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Cancel(props) {
  const { without_circle, ...rest } = props;
  const circle = without_circle ? null : (
    <circle cx={16} cy={16} r={14} stroke={props.color || PLATINUM_COLOR} strokeWidth={2} />
  );
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...rest}>
      {circle}
      <path
        d="M21.5 10.5l-11 11m11 0l-11-11"
        stroke={props.color || PLATINUM_COLOR}
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Copy(props) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <rect
        x={4}
        y={10}
        width={18}
        height={18}
        rx={2}
        stroke={props.color || PLATINUM_COLOR}
        strokeWidth={2}
      />
      <path
        d="M20.5 4h-3m-5 0H12a2 2 0 00-2 2v.5M25.5 4h.5a2 2 0 012 2v.5m0 5v3m0 5v.5a2 2 0 01-2 2h-.5"
        stroke={props.color || PLATINUM_COLOR}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Visa(props) {
  return (
    <svg width={50} height={25} viewBox="0 0 150 75" fill="none" {...props}>
      <path fill="#fff" d="M0 0h150v75H0z" />
      <path
        d="M68.334 52.887h-8.1l5.065-31.32h8.1l-5.065 31.32zm29.364-30.55A19.966 19.966 0 0090.435 21c-8 0-13.633 4.263-13.67 10.365-.063 4.494 4.033 6.996 7.1 8.494 3.135 1.534 4.204 2.534 4.204 3.899-.037 2.097-2.535 3.064-4.87 3.064-3.234 0-4.964-.498-7.598-1.664l-1.07-.502-1.133 7.033c1.902.862 5.402 1.632 9.037 1.664 8.5 0 14.034-4.199 14.098-10.693.032-3.566-2.13-6.3-6.799-8.53-2.835-1.433-4.568-2.4-4.568-3.867.032-1.336 1.465-2.7 4.664-2.7 2.075-.06 4.137.351 6.034 1.203l.733.332 1.1-6.762zm10.77 19.457l3.231-8.765c-.032.068.669-1.83 1.065-2.996l.569 2.696s1.533 7.498 1.866 9.065h-6.735.004zm9.998-20.227H112.2c-1.934 0-3.404.567-4.236 2.6l-12.032 28.72h8.5l1.702-4.696h10.398c.236 1.097.969 4.696.969 4.696H125l-6.534-31.32zm-64.999 0l-7.935 21.357-.865-4.332c-1.465-4.996-6.066-10.426-11.199-13.126l7.267 27.389h8.568l12.733-31.288h-8.569z"
        fill="#00579F"
      />
      <path
        d="M38.169 21.567H25.132l-.132.636c10.17 2.595 16.9 8.862 19.667 16.393l-2.835-14.397c-.464-2-1.898-2.563-3.663-2.632z"
        fill="#00579F"
      />
    </svg>
  );
}

export function MasterCard(props) {
  return (
    <svg width={50} height={25} viewBox="0 0 150 75" fill="none" {...props}>
      <path d="M88.194 15.523h-26.38v43.085h26.38V15.523z" fill="#FF5F00" />
      <path
        d="M64.531 37.07a27.354 27.354 0 0110.465-21.54 27.4 27.4 0 100 43.086 27.353 27.353 0 01-10.465-21.547z"
        fill="#EB001B"
      />
      <path
        d="M116.712 54.05v-.883h.38v-.183h-.905v.183h.357v.883h.168zm1.758 0v-1.066h-.274l-.32.761-.32-.761h-.273v1.066h.197v-.807l.297.692h.206l.297-.692v.806h.19zM119.33 37.07A27.398 27.398 0 0189.004 64.31a27.399 27.399 0 01-14.008-5.703 27.4 27.4 0 000-43.085 27.399 27.399 0 0144.334 21.539v.008z"
        fill="#F79E1B"
      />
    </svg>
  );
}

export function LightBulb(props) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M10.584 23h10.794m-10.794 0l.552 3m-.552-3s-.23-.748-2.084-3C6.647 17.748 6 15.13 6 12.963 6 8.013 10.477 3 16 3s10 5.013 10 9.963c0 2.167-.647 4.785-2.5 7.037s-2.122 3-2.122 3m0 0l-.553 3m-9.689 0l.15 1.24A2 2 0 0013.273 29h5.433a2 2 0 001.989-1.784L20.825 26m-9.689 0h9.69"
        stroke={props.color || PLATINUM_COLOR}
        strokeWidth={2}
        strokeLinecap="round"
      />
      {props.light ? (
        <path
          d="M16 3C10.477 3 6 8.013 6 12.963c0 2.167.647 4.785 2.5 7.037a28.273 28.273 0 011.333 1.734c.503.719 1.348 1.266 2.225 1.266h7.915c.844 0 1.65-.508 2.137-1.198.315-.447.761-1.038 1.39-1.802 1.853-2.252 2.5-4.87 2.5-7.037C26 8.013 21.523 3 16 3z"
          fill={props.color || PLATINUM_COLOR}
          stroke={props.color || PLATINUM_COLOR}
          strokeWidth={2}
          strokeLinecap="round"
        />
      ) : null}
    </svg>
  );
}

export function DeliveryStatus(props) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M19.714 8L8.272 22.712a.857.857 0 01-1.241.119l-4.215-3.688"
        stroke={props.color || PLATINUM_COLOR}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      {props.status === 'read' ? (
        <path
          d="M28 8l-1.715 2.204-9.69 12.458a.857.857 0 01-1.282.08L13.57 21"
          stroke={props.color || PLATINUM_COLOR}
          strokeWidth={2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ) : null}
    </svg>
  );
}

export function Search(props) {
  return (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" {...props}>
      <path
        d="M19.5 19.52a8.5 8.5 0 10-12-12.042 8.5 8.5 0 0012 12.043zm0 0L28 28"
        stroke={props.color || PLATINUM_COLOR}
        strokeWidth={2}
        strokeLinecap="round"
      />
    </svg>
  );
}

export function Spinner(props) {
  const { className, backgroundColor, strokeWidth = 4, ...rest_props } = props;
  return (
    <svg
      className={classNames('Spinner', className)}
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      {...rest_props}
    >
      {backgroundColor ? (
        <circle cx={16} cy={16} r={12} stroke={backgroundColor} strokeWidth={strokeWidth} />
      ) : null}
      <path
        className="Spinner__inner"
        d="M28 16c0 6.627-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4"
        stroke={props.color || PLATINUM_COLOR}
        strokeWidth={strokeWidth}
        strokeMiterlimit={2.097}
      />
    </svg>
  );
}

export function ReadAction(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16 6C8.614 6 3.493 13.551 2.278 15.53a.889.889 0 000 .94C3.493 18.449 8.614 26 16 26c7.386 0 12.507-7.551 13.722-9.53a.889.889 0 000-.94C28.507 13.551 23.386 6 16 6z"
        stroke={props.color || PLATINUM_COLOR}
        strokeWidth={2}
        strokeLinejoin="round"
      />
      <circle cx={16} cy={16} r={4.5} stroke={props.color || PLATINUM_COLOR} strokeWidth={2} />
    </svg>
  );
}

export function UnreadAction(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.278 15.53l-.852-.523.852.523zm27.444 0l.852-.523-.852.523zm-27.444.94l-.852.523.852-.523zm27.444 0l.852.523-.852-.523zm-23.93 9.323a1 1 0 101.415 1.414l-1.414-1.414zM27.208 7.207a1 1 0 00-1.414-1.414l1.414 1.414zm-7.564 6.15l.707.707-.707-.707zM13.269 24.62a1 1 0 10-.538 1.926l.538-1.926zm14.342-13.562a1 1 0 00-1.487 1.338l1.487-1.338zM3.13 16.053c.583-.95 2.11-3.243 4.366-5.29C9.761 8.712 12.657 7 16 7V5c-4.043 0-7.4 2.064-9.847 4.282-2.454 2.224-4.095 4.695-4.727 5.725l1.704 1.046zM16 27c4.044 0 7.4-2.064 9.847-4.282 2.454-2.224 4.095-4.695 4.727-5.725l-1.704-1.046c-.583.95-2.11 3.243-4.366 5.29C22.239 23.288 19.343 25 16 25v2zm12.87-10.947a.105.105 0 01-.013-.053c0-.024.007-.043.013-.053l1.704 1.046a1.889 1.889 0 000-1.986l-1.704 1.046zM1.426 15.007a1.889 1.889 0 000 1.986l1.704-1.046c.006.01.013.03.013.053a.105.105 0 01-.013.053l-1.704-1.046zM12.5 16a3.5 3.5 0 013.5-3.5v-2a5.5 5.5 0 00-5.5 5.5h2zm1.445 2.834A3.494 3.494 0 0112.5 16h-2c0 1.831.896 3.454 2.27 4.452l1.175-1.618zm.12 1.516l6.285-6.286-1.414-1.414-6.286 6.286 1.414 1.414zM16 12.5c1.164 0 2.196.567 2.834 1.445l1.618-1.176A5.494 5.494 0 0016 10.5v2zM7.207 27.207l2.687-2.687-1.414-1.414-2.687 2.687 1.414 1.414zm2.687-2.687l4.17-4.17-1.414-1.414-4.17 4.17 1.414 1.414zm-8.468-7.527c.815 1.328 3.364 5.144 7.214 7.658l1.093-1.675C6.26 20.709 3.9 17.201 3.13 15.946l-1.704 1.047zm18.924-2.929l4.338-4.338-1.414-1.414-4.338 4.338 1.414 1.414zm4.338-4.338l2.52-2.519-1.415-1.414-2.52 2.52 1.415 1.413zM16 7c2.804 0 5.294 1.203 7.368 2.81l1.225-1.581C22.306 6.457 19.395 5 16 5v2zm-3.27 19.545c1.033.289 2.125.455 3.27.455v-2a10.1 10.1 0 01-2.73-.38l-.54 1.925zm13.394-14.15a25.944 25.944 0 012.746 3.658l1.704-1.046a27.95 27.95 0 00-2.963-3.95l-1.487 1.338z"
        fill={props.color || PLATINUM_COLOR}
      />
    </svg>
  );
}

export function More(props) {
  const fill = props.color || PLATINUM_COLOR;
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx={11.5} cy={16.5} r={1.5} fill={fill} />
      <circle cx={20.5} cy={16.5} r={1.5} fill={fill} />
      <circle cx={16} cy={16.5} r={1.5} fill={fill} />
    </svg>
  );
}

export function Like(props) {
  const { is_filled, color, ...rest } = props;
  const stroke = color || PLATINUM_COLOR;
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M22.036 5C17.857 5 16 8.667 16 8.667S14.143 5 9.964 5C5.786 5 3 8.667 3 12.333 3 16 4.427 17.867 7.643 21.042 10.429 23.792 16 27 16 27s5.571-3.208 8.357-5.958C27.573 17.867 29 16 29 12.333 29 8.667 26.214 5 22.036 5z"
        stroke={stroke}
        fill={is_filled ? stroke : 'none'}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Template(props) {
  const { is_filled, color, ...rest } = props;
  const stroke = color || PLATINUM_COLOR;
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M15.902 7.385l12.004 7.335a1.5 1.5 0 010 2.56l-12.004 7.335c-1.236.756-2.72-.506-2.17-1.847l2.536-6.2a1.5 1.5 0 000-1.136l-2.537-6.2c-.548-1.34.935-2.603 2.17-1.847zM11 16H2m8-5H4m6 10H4"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Send(props) {
  const { is_filled, color, ...rest } = props;
  const stroke = color || PLATINUM_COLOR;
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M13 15.5L4.38 8.676C3.266 7.794 3.89 6 5.311 6h22.886c1.198 0 1.913 1.335 1.248 2.332L17.194 26.709c-.766 1.15-2.546.74-2.734-.627L13 15.5zm0 0L29.105 7"
        stroke={stroke}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function ArrowBack(props) {
  const { color, ...rest } = props;
  const stroke = color || PLATINUM_COLOR;
  return (
    <svg
      width={49}
      height={10}
      viewBox="0 0 49 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.747.342l-3.5 4L.671 5l.576.658 3.5 4 1.506-1.316L4.203 6H49V4H4.204l2.049-2.342L4.747.342z"
        fill={stroke}
      />
    </svg>
  );
}

export function Unlink(props) {
  return (
    <svg width={32} height={32} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.975 9.075c-1 0-1.8.3-2.5 1l-2.2 2.1-1.9-1.9 2.2-2c1.2-1.2 2.7-1.8 4.4-1.8 1.3 0 2.5.4 3.5
                1.1l2.2-2.2c.5-.5 1.4-.5 1.9 0s.5 1.4 0 1.9l-2.2 2.2c1.4 2.3 1.1 5.5-.9 7.5l-2.2 2.2-1.9-1.9
                2.2-2.2c.9-1 1.2-2.4.8-3.6l-1.8 1.8c-.3.3-.7.4-1 .4-.4 0-.7-.1-1-.4-.6-.5-.6-1.4-.1-1.8l2-2c-.4-.3-1-.4-1.5-.4Zm-4.1
                12.8 2.4-2.4 2 1.9-2.4 2.4c-1.2 1.2-2.7 1.8-4.4 1.8-1.1 0-2.2-.3-3.1-.9l-2 2c-.3.3-.7.4-1 .4-.4 0-.7-.1-1-.4-.5-.5-.5-1.4
                0-1.9l1.9-1.9c-1.7-2.4-1.5-5.7.7-7.9l2.4-2.4 1.9 2.1-2.4 2.4c-1.1 1.1-1.3 2.7-.7 4l2.3-2.3c.5-.5 1.4-.5 1.9 0s.5 1.4 0
                1.9l-2.1 2.1c1.2.3 2.7.1 3.6-.9Z"
        fill="#333"
      />
    </svg>
  );
}

export function Alert(props) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle
        cx={16}
        cy={16}
        r={14}
        transform="rotate(180 16 16)"
        stroke="#1A2B49"
        strokeWidth={2}
      />
      <circle cx={16} cy={22.5} r={1.5} transform="rotate(180 16 22.5)" fill="#1A2B49" />
      <path d="M16 17V8" stroke="#1A2B49" strokeWidth={2} strokeLinecap="round" />
    </svg>
  );
}
